module.exports = __webpack_public_path__ + "static/media/madfit-10.8a185d52.jpg";